import { DateTime } from 'luxon';
import {
  FloorExceptionalClosingHours,
  FloorExceptionalClosingHoursResponse,
  FloorExceptionalClosingHoursResponseStatusEnum,
} from '../model';
import { axiosManager } from '../config';

export interface IGetFloorExceptionalClosingHoursByFloorIdParameters {
  floorId?: number;
  from: DateTime;
  to: DateTime;
  openingStatus: FloorExceptionalClosingHoursResponseStatusEnum;
}

export const FloorExceptionalClosingHoursService = {
  path: 'floor_exceptional_closing_hours',

  getExceptionalClosingHoursById(id: number): Promise<FloorExceptionalClosingHoursResponse> {
    const url = `${this.path}/${id}`;

    return axiosManager
      .getInstance()
      .get(url)
      .then((res) => res.data);
  },

  getFloorExceptionalClosingHoursByFloorId(
    options?: IGetFloorExceptionalClosingHoursByFloorIdParameters
  ): Promise<FloorExceptionalClosingHoursResponse[]> {
    const params = this.createGetFloorExceptionalClosingHoursByIdParams(options);

    const url = `${this.path}`;

    return axiosManager
      .getInstance()
      .get(url, { params })
      .then((res) => res.data);
  },

  create(floorExceptionalClosingHours: FloorExceptionalClosingHours): Promise<FloorExceptionalClosingHoursResponse> {
    const url = `${this.path}`;

    return axiosManager
      .getInstance()
      .post(url, floorExceptionalClosingHours)
      .then((res) => res.data);
  },

  update(
    id: number,
    floorExceptionalClosingHours: FloorExceptionalClosingHours
  ): Promise<FloorExceptionalClosingHoursResponse> {
    const url = `${this.path}/${id}`;

    return axiosManager
      .getInstance()
      .put(url, floorExceptionalClosingHours)
      .then((res) => res.data);
  },

  delete(id: number): Promise<never> {
    const url = `${this.path}/${id}`;

    return axiosManager.getInstance().delete(url);
  },

  createGetFloorExceptionalClosingHoursByIdParams(
    options?: IGetFloorExceptionalClosingHoursByFloorIdParameters
  ): URLSearchParams {
    const params = new URLSearchParams();

    if (!options) {
      return params;
    }

    if (options.floorId) {
      params.set('floorId', options.floorId.toString());
    }

    if (options.from) {
      params.set('dateFrom', options.from.toUTC().toISO() ?? 'Invalid Date');
    }

    if (options.to) {
      params.set('dateTo', options.to.toUTC().toISO() ?? 'Invalid Date');
    }

    params.set('openingStatus', options.openingStatus);

    return params;
  },
};
